import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import LogoutSuccess from '@/components/LogoutSuccess';
import ErrorComponent from '@/components/Error';
import DashboardComponent from '@/components/Dashboard';
import EmailDashboardComponent from '@/components/EmailDashboard';
import DetailsComponent from '@/components/Details';
import SettingsComponent from '@/components/Settings';
import NotificationsAllComponent from '@/components/NotificationsAll'
import BillingComponent from '@/components/Billing'
import MarketPlaceComponent from '@/components/MarketPlace'
import PluginSettingsComponent from '@/components/PluginSettings'
import WorkflowOrchestratorComponent from '@/components/WorkflowOrchestrator'

import auth from '../app/auth';
//import UserInfoStore from '../app/user-info-store';
import { store } from '../app/user-info-store'
import UserInfoApi from '../app/user-info-api';


Vue.use(Router)

// FUNCTIONS
function requireAuth(to, from, next) {
  if (!auth.auth.isUserSignedIn()) {
    //UserInfoStore.setLoggedIn(false);
    store.commit('setLoggedIn', false)
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    });
  } else {
    UserInfoApi.getUserInfo().then(response => {
      //UserInfoStore.setLoggedIn(true);
      store.commit('setLoggedIn', true)
      //UserInfoStore.setCognitoInfo(response);
      store.commit('setCognitoInfo', response)
      next();
    });
  }
}

// ROUTES
export default new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: DashboardComponent,
      beforeEnter: requireAuth
    },
    {
      path: '/dashboard-email',
      name: 'Email Dashboard',
      component: EmailDashboardComponent,
      beforeEnter: requireAuth
    },
    {
      path: '/details',
      name: 'Details',
      component: DetailsComponent,
      beforeEnter: requireAuth
    },
    {
      path: '/settings',
      name: 'Settings',
      component: SettingsComponent,
      beforeEnter: requireAuth
    },
    {
      path: '/notifications',
      name: 'Notifications',
      component: NotificationsAllComponent,
      beforeEnter: requireAuth
    },
    {
      path: '/billing',
      name: 'Billing',
      component: BillingComponent,
      beforeEnter: requireAuth
    },
    {
      path: '/marketplace',
      name: 'marketPlace',
      component: MarketPlaceComponent,
      beforeEnter: requireAuth
    },
    {
      path: '/plugin/:plugin',
      name: 'plugin',
      component: PluginSettingsComponent,
      beforeEnter: requireAuth
    },
    {
      path: '/workflow/',
      name: 'workflow',
      component: WorkflowOrchestratorComponent
      //beforeEnter: requireAuth
    },
    {
      path: '/',
      name: 'Home',
      beforeEnter: requireAuth,
      beforeEnter(to, from, next) {
        // we use beforeEnter to check everything before rendering the component.
        // auth is the wrapper we have for Cognito (auth.js)
        var currUrl = window.location.href;
        //console.log(currUrl);
        next("/dashboard");
      }

    },
    {
      path: '/login', beforeEnter(to, from, next) {
        auth.auth.getSession();
      }
    },
    {
      path: '/login/oauth2/code/cognito',
      beforeEnter(to, from, next) {
        // we use beforeEnter to check everything before rendering the component.
        // auth is the wrapper we have for Cognito (auth.js)
        var currUrl = window.location.href;
        //console.log(currUrl);
        auth.auth.parseCognitoWebResponse(currUrl);
        next();
      }
    },
    {
      path: '/logout',
      name: 'Logout',
      component: LogoutSuccess,
      beforeEnter(to, from, next) {
        // we use beforeEnter to check everything before rendering the component.
        // auth is the wrapper we have for Cognito (auth.js)
        auth.logout();
        next("/");
      }
    },
    {
      path: '/error',
      name: 'Error',
      component: ErrorComponent
    }
  ]
})


